import React, {useCallback, useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {LoadingOverlay} from 'aba-ui'
import RTIDAPI from '../../helpers/AxiosInstance'

const EXCHANGE_URL = `${process.env.REACT_APP_API_URL}authentication/residentreach`
const RR_LANDING_URL = process.env.REACT_APP_RR_LANDING_URL
const RR_ORIGIN = new URL(RR_LANDING_URL).origin

export default function ResidentReach() {
    const navigate = useNavigate()
    const [token, setToken] = useState('')
    const [loading, setLoading] = useState(true)
    const iframeRef = useRef(null)

    useEffect(() => {
        const load = async () => {
            setLoading(true)
            try {
                try {
                    await RTIDAPI.get('authentication/residentreach')
                } catch (error) {
                    if (error?.response?.status === 403) {
                        navigate('/residentListing')
                        return
                    }
                    console.error(error)
                    return
                }

                try {
                    const {data} = await RTIDAPI.get('authentication/token')
                    setToken(data)
                } catch (error) {
                    console.error(error)
                }
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [navigate])

    const postToken = useCallback(() => {
        const target = iframeRef.current?.contentWindow
        if (!target || !token) return
        target.postMessage(
            {
                type: 'rr:auth-token',
                token,
                exchangeUrl: EXCHANGE_URL,
                username: RTIDAPI.defaults.headers.common.ProgramHeaderKey,
            },
            RR_ORIGIN,
        )
    }, [token])

    // Wait for Resident Reach to signal its listener is live
    useEffect(() => {
        if (!token) return
        const handleMessage = (event) => {
            if (event.origin !== RR_ORIGIN) return
            if (event.source !== iframeRef.current?.contentWindow) return
            if (event.data?.type !== 'rr:auth-ready') return
            postToken()
        }
        window.addEventListener('message', handleMessage)
        return () => window.removeEventListener('message', handleMessage)
    }, [token, postToken])

    if (loading) {
        return <LoadingOverlay title="Checking Access" />
    }

    if (!token) {
        return null
    }

    return (
        <iframe
            ref={iframeRef}
            title="Resident Reach"
            src={RR_LANDING_URL}
            style={{flex: 1, border: 'none', width: '100%'}}
        />
    )
}
